import { gql } from 'graphql-tag';

export const GET_CUSTOM_FIELD_VALUES = gql`
  query Idce684ab844aeae3b40cf2922a8304803(
    $companyId: ID!
    $customFieldIds: [ID!]
    $customFieldValuesIds: [ID!]
  ) {
    __typename
  }
`;
